import script from "./form-tag.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-tag.vue?vue&type=script&setup=true&lang=ts"

import "./form-tag.vue?vue&type=style&index=0&id=3599002b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3599002b"]])

export default __exports__